
import viplist from '@/components/shop/Viplist'
import Monitoringquota from '@/components/shop/Monitoringquota'
import smsPackage from '@/components/shop/SMSpackage'
import telephone from  '@/components/shop/Telephonepackage'
import Ipblack from '@/components/shop/Ipblack'
export default {
    components:{
      viplist,
      Monitoringquota,
      smsPackage,
      telephone,
      Ipblack
    },
    data(){
        return {
          activeName:"1",
          VIPlist:[]
        }
    },
    created () {
    },
    methods:{

    },

}
